// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsTempJanssenGECheckPatient {
    static getAttributeTypeMap() {
        return ScriptsTempJanssenGECheckPatient.attributeTypeMap;
    }
}
ScriptsTempJanssenGECheckPatient.discriminator = undefined;
ScriptsTempJanssenGECheckPatient.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "string"
    },
    {
        "name": "addressLine1",
        "baseName": "addressLine1",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    }
];
//# sourceMappingURL=scriptsTempJanssenGECheckPatient.js.map